import axios from 'axios'
import { Message } from 'element-ui'
import errorCode from '@/utils/errorCode'
import store from '@/store'
import router from '@/router'

let isNotShowMsg = false
// 设置默认 Content-Type
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

// 创建 axios 实例
const service = axios.create({
  baseURL: 'https://pwgateway.hu0tao.com',
  // baseURL: 'http://192.168.8.115:8080',
  timeout: 120000,
})

// request 拦截器
service.interceptors.request.use(config => {
  if (store.getters['user/isAuthenticated'] && store.state.user.token) {
    config.headers['Authorization'] = 'Bearer ' + store.state.user.token
  }
  if(store.state.shop.shop) {
    config.headers['deptid'] = store.state.shop.shop.deptId
  }
  if(config.isNotShowMsg) {
    isNotShowMsg = true
  }
  if (config.method === 'get' && config.params) {
    let url = config.url + '?';
    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName];
      const part = encodeURIComponent(propName) + "=";
      if (value != null) {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            const params = propName + '[' + key + ']';
            const subPart = encodeURIComponent(params) + "=";
            url += subPart + encodeURIComponent(value[key]) + "&";
          }
        } else {
          url += part + encodeURIComponent(value) + "&";
        }
      } else {
        url += part + "&";
      }
    }
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  return config;
}, error => {
  return Promise.reject(error)
})

// response 拦截器
service.interceptors.response.use(
  res => {
    const code = res.data.code || 200;
    const msg = errorCode[code] || res.data.msg || errorCode['default'];
    if (code === 401) {
      Message({
        message: '登录状态已过期，请重新登录',
        type: 'error',
        duration: 3000
      })
      store.dispatch('user/logout')
      if (router.currentRoute.path !== '/login') {
        router.push('/login')
      }
      return Promise.reject(new Error('Token expired'))
    } else if (code === 500) {
      if(!isNotShowMsg) {
        Message({
          message: msg || '服务器内部错误',
          type: 'error',
          duration: 5000
        })
      }
      return Promise.reject(new Error(msg))
    } else if (code !== 200) {
      Message({
        message: msg,
        type: 'error',
        duration: 5000
      })
      return Promise.reject(new Error(msg))
    } else {
      return res.data
    }
  },
  error => {
    let { message } = error;
    if (message === "Network Error") {
      message = "网络连接失败!";
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
      message = "系统接口 " + message.substr(message.length - 3) + " 异常";
    }

    Message({
      message: message,
      type: 'error',
      duration: 5000,
    })
    return Promise.reject(error)
  }
)

export default service